import 'babel-polyfill';
import objectFitImages from 'object-fit-images';
import './support.js';
import './news.js';
import 'date-input-polyfill';

document.addEventListener('DOMContentLoaded', function() {
  for (let el of document.querySelectorAll('input[type=date]')) {
    el.addEventListener('keydown', (e) => e.preventDefault())
  }
  // Scroll to top.
  document.querySelector('#js-scroll-to-top').addEventListener('click', () => {
    $('html, body').animate({scrollTop: 0})
  })

  // Megamenu.
  if (window.location.href.match(/products\/prod_keyword/)) {
    document.querySelector('#mega-menu-item-433').classList.add('mega-current-menu-item')
  }
  if (window.location.href.match(/products\/prod_category/)) {
    document.querySelector('#mega-menu-item-433').classList.add('mega-current-menu-item')
  }
  if (window.location.href.match(/products\/prod_brand/)) {
    document.querySelector('#mega-menu-item-71').classList.add('mega-current-menu-item')
  }
  if (window.location.href.match(/products?\/$/)) {
    document.querySelector('#mega-menu-item-434').classList.add('mega-current-menu-item')
  }
  if (window.location.href.match(/news\//)) {
    document.querySelector('#mega-menu-item-434').classList.add('mega-current-menu-item')
  }

})

window.addEventListener('load', function() {
  objectFitImages('.object-fit--contain')
  objectFitImages('.object-fit--cover')
  objectFitImages('.object-fit--scale-down')
  objectFitImages('.object-fit--fill')
})



// WEBPACK FOOTER //
// ./entry.js